/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Videos_AddInputs */

const cs_videos_add = /** @type {(inputs: Videos_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat videa`)
};

const en_videos_add = /** @type {(inputs: Videos_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add videos`)
};

/**
* | output |
* | --- |
* | "Add videos" |
*
* @param {Videos_AddInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const videos_add = /** @type {((inputs?: Videos_AddInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Videos_AddInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_videos_add(inputs)
	return cs_videos_add(inputs)
});